import { computed, inject, Injectable, signal, Signal } from '@angular/core';
import { ApplicationDataState } from './application.model';
import { initialValue, productionInitialValue } from './application-store.init';
import { AppConfig } from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class ApplicationStore {
  private readonly appConfig = inject(AppConfig);

  private readonly stateSignal = signal<ApplicationDataState>(
    this.appConfig.production ? productionInitialValue : initialValue
  );

  get value(): ApplicationDataState {
    return this.stateSignal();
  }

  instant<F extends keyof ApplicationDataState>(field: F): Signal<ApplicationDataState[F]> {
    return computed(() => this.stateSignal()[field]);
  }

  update<F extends keyof ApplicationDataState>(field: F, data: ApplicationDataState[F]): void {
    this.stateSignal.update(currentState => {
      const newState = { ...currentState };
      newState[field] = data;
      return newState;
    });
  }

  reset(value: ApplicationDataState | null = null): void {
    this.stateSignal.set(value ?? (this.appConfig.production ? productionInitialValue : initialValue));
  }
}
